/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_UnsupportedInputs */



/**
* | output |
* | --- |
* | "Not supported on this device" |
*
* @param {Notifications_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_unsupported = /** @type {((inputs?: Notifications_UnsupportedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_UnsupportedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non pris en charge sur cet appareil")
	if (locale === "es") return /** @type {LocalizedString} */ ("No compatible con este dispositivo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não suportado neste dispositivo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non supportato su questo dispositivo")
	return /** @type {LocalizedString} */ ("Not supported on this device")
});